import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { db } from '../App';
import { collection, addDoc, serverTimestamp, doc, updateDoc } from 'firebase/firestore';

const TaskCreationModal = ({ show, onClose, taskData, user }) => {
    const [assignee, setAssignee] = useState('');
    const [priority, setPriority] = useState('Medium');
    const [dueDate, setDueDate] = useState('');

    useEffect(() => {
        if (taskData) {
            setAssignee('');
            setPriority('Medium');
            setDueDate('');
        }
    }, [taskData]);

    const handleSaveTask = async () => {
        if (!assignee || !dueDate) {
            alert("Please fill out all fields.");
            return;
        }
        const newTask = {
            ...taskData,
            assignee,
            priority,
            dueDate: new Date(dueDate),
            status: 'Pending',
            approvalStatus: 'Pending Approval',
            createdDate: serverTimestamp()
        };
        await addDoc(collection(db, `users/${user.uid}/tasks`), newTask);

        if (taskData.assetId) {
            const assetDocRef = doc(db, `users/${user.uid}/assets/${taskData.assetId}`);
            await updateDoc(assetDocRef, { remediationStatus: 'Pending Approval' });
        }
        onClose();
    };

    if (!show) return null;

    return (
        <Modal show={show} onClose={onClose} title="Create New Remediation Task">
            <div className="space-y-4 text-gray-300">
                <div>
                    <label className="font-bold text-sky-400">Task Title</label>
                    <p>{taskData?.title}</p>
                </div>
                 <div>
                    <label className="font-bold text-sky-400">Remediation Guide</label>
                    <p className="whitespace-pre-wrap p-2 bg-sky-900/20 rounded-md max-h-40 overflow-y-auto">{taskData?.remediationGuide}</p>
                </div>
                 <div>
                    <label className="font-bold text-sky-400">Assignee</label>
                    <input type="text" value={assignee} onChange={e => setAssignee(e.target.value)} placeholder="e.g., John Doe" className="form-input w-full p-2 rounded-md" />
                </div>
                <div className="flex gap-4">
                    <div className="flex-1">
                        <label className="font-bold text-sky-400">Priority</label>
                        <select value={priority} onChange={e => setPriority(e.target.value)} className="form-input w-full p-2 rounded-md">
                            <option className="bg-gray-800">Low</option>
                            <option className="bg-gray-800">Medium</option>
                            <option className="bg-gray-800">High</option>
                             <option className="bg-gray-800">Critical</option>
                        </select>
                    </div>
                    <div className="flex-1">
                        <label className="font-bold text-sky-400">Due Date</label>
                        <input type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} className="form-input w-full p-2 rounded-md" />
                    </div>
                </div>
                <button onClick={handleSaveTask} className="login-button w-full py-3 font-bold rounded-md">Submit for Approval</button>
            </div>
        </Modal>
    );
};

export default TaskCreationModal;
